import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { PosComprobantePageContent } from '../components/pos-comprobante-page-content';

/** Tipos de venta admitidos por la pantalla. */
const MODOS = ['comprobante', 'credito', 'consumo', 'calibracion'] as const;

/**
 * Página independiente para registrar cualquier tipo de venta del turno:
 * comprobante, venta a crédito, consumo interno o calibración.
 *
 * El tipo se puede preseleccionar con `?modo=`, de modo que un enlace pueda abrir
 * directamente la pestaña correspondiente.
 */
export function TurnoComprobantePage() {
  const navegar = useNavigate();
  const [parametros] = useSearchParams();
  /** Contador que obliga a montar de nuevo el formulario tras registrar una operación. */
  const [reinicio, setReinicio] = useState(0);
  const solicitado = parametros.get('modo');
  const modoInicial = MODOS.find((modo) => modo === solicitado) ?? 'comprobante';

  return (
    <PosComprobantePageContent
      key={`${modoInicial}-${reinicio}`}
      modoInicial={modoInicial}
      onClose={() => navegar('/turno')}
      onVolverAlComprobante={(modo) => {
        // Vuelve a esta pantalla con el tipo elegido en la URL y el formulario limpio.
        setReinicio((actual) => actual + 1);
        navegar(`/turno/comprobante?modo=${modo}`, { replace: true });
      }}
    />
  );
}
